import produce from 'immer';
import { registerReducer } from '../../../StateSetup/RootReducer';

const CANADA_POST_KEY = window.__ENV__.CANADA_POST_KEY;
const CANADA_POST_ADDRESS_DETAIL_URL = window.__ENV__.CANADA_POST_ADDRESS_DETAIL_API_URL;

// Action names
const ACTION_NAME_PREFIX = 'action/getdropDownSelectedAddressDetails';
export const REQUEST_ACTION_NAME = `${ACTION_NAME_PREFIX}/request`;
export const RESPONSE_ACTION_NAME = `${ACTION_NAME_PREFIX}/response`;
export const ERROR_ACTION_NAME = `${ACTION_NAME_PREFIX}/error`;

/**
 * Gets the full address details based on the id which is received in detail api while calling
 * GetCanadaPostAddressSuggestion. Returns address detail like city, province and postal code of
 * the address using id of that address and Canada Post API. Document link for Canada Post
 * API - https://www.canadapost-postescanada.ca/ac/support/api/addresscomplete-interactive-retrieve/
 * @param {string} id address id from Canada Post API dropdown list, used here to get detail of that address.
 * @param {object} logger
 * @
 */
export const GetCanadaPostAddressDetails = (id) => {
    return async (dispatch, getState, { logger }) => {
        // step 1: Request Action
        dispatch({ type: REQUEST_ACTION_NAME });

        const transactionId = logger.generateGuid();

        logger.info(`${ACTION_NAME_PREFIX}: Fetching address detail from canada post api.`, {
            correlation: { transactionId },
        });

        // step 2: await Web service call
        const canadaPostDetails = await fetch(`${CANADA_POST_ADDRESS_DETAIL_URL}?Key=${CANADA_POST_KEY}&Id=${id}`, {
            method: 'POST',
        });
        const canadaPostDetailsResponse = await canadaPostDetails.json();

        if (canadaPostDetailsResponse && canadaPostDetailsResponse.Items && canadaPostDetailsResponse.Items[0].Error) {
            const { Error: error, Cause } = canadaPostDetailsResponse.Items[0];
            logger.error(
                `${ACTION_NAME_PREFIX}: Failure when fetching details of the address from Canada Post API. Code: ${error} Reason: ${Cause}`,
                { correlation: { transactionId } }
            );
            return dispatch({
                type: ERROR_ACTION_NAME,
                code: error,
                message: Cause,
            });
        }
        // step 3: Response Action
        return dispatch({ type: RESPONSE_ACTION_NAME, data: canadaPostDetailsResponse, success: true });
    };
};

/**
 * Updating isLoadingdropDownSelectedAddressDetail to true when Canada Post Api is being called to get address detail.
 * @param {object} state
 */
export const requestReducer = produce((state) => {
    state.CanadaPostAddress.isLoadingdropDownSelectedAddressDetail = true;
});

/**
 * Fired off when the request receives theresponse.
 * @param {object} state
 * @param {object} action
 */
export const responseReducer = produce((state, action) => {
    state.CanadaPostAddress.isLoadingdropDownSelectedAddressDetail = false;
    state.Errors.dropDownSelectedAddressDetail.hasError = false;
    state.Errors.dropDownSelectedAddressDetail.code = '';
    state.Errors.dropDownSelectedAddressDetail.message = '';
    if (action.data) {
        state.CanadaPostAddress.dropDownSelectedAddressDetail = action.data.Items[0];
    } else {
        state.CanadaPostAddress.dropDownSelectedAddressDetail = {};
    }
});

/**
 * Fired off when the request encouters an error.
 * @param {object} state
 * @param {object} action
 */
export const errorReducer = produce((state, action) => {
    state.CanadaPostAddress.isLoadingdropDownSelectedAddressDetail = false;
    state.Errors.dropDownSelectedAddressDetail.hasError = true;
    state.Errors.dropDownSelectedAddressDetail.code = action.code;
    state.Errors.dropDownSelectedAddressDetail.message = action.message;
});

registerReducer(REQUEST_ACTION_NAME, requestReducer);
registerReducer(RESPONSE_ACTION_NAME, responseReducer);
registerReducer(ERROR_ACTION_NAME, errorReducer);
